<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        <span>{{ 'savedCart.CRDselect' | cxTranslate }}</span>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('close')"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row">
        <div class="cx-dialog-info col-md-12">
            <vs-date-picker
                class="date-picker-PDP"
                (selectedDate)="dateChange($event)"
                [defaultDate]="selectedCRD"
                [filterWeekend]="filterWeekend"
                [min]="minDate"
            >
            </vs-date-picker>
        </div>
        <div class="error-msg-txt" *ngIf="showErrorTxt">Please select a date</div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 action-container">
          <button cxAutoFocus class="vs-text-btn" (click)="closeModal('close')">
            {{ 'savedCart.cancel' | cxTranslate }}
          </button>
          <button
            class="vs-primary-btn"
            (click)="closeModal('crd-selected')"
          >
            <span>
              {{ 'savedCart.continue' | cxTranslate }}
            </span>            
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
